import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Project } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useRegenerateSecretKey = (
  projectId: string,
  options: Omit<UseMutationOptions<Project, UnprocessableEntityError, void, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Project, UnprocessableEntityError, void, unknown>({
    mutationFn: async (): Promise<Project> => {
      const response = await api.post<Project>(`/projects/${projectId}/regenerate-secret-key`);
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
    },
    ...options
  });
};

